
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shorts/[...params]",
      function () {
        return require("private-next-pages/shorts/[...params].tsx");
      }
    ]);
  